import { AxiosInstance } from 'axios';
import http from '@/views/student/http';

function submitSinCtor(http: AxiosInstance) {
  return async (projectId: string, sessionId: string) => {
    const { data } = await http.post(`/checkout/${projectId}/${sessionId}/archive-credit-check`);
    return data;
  };
}

export default submitSinCtor(http);
